import React from 'react';
import { FormViewerStatic } from '../../components/root/form-viewer-static';
import { useFormActions } from '../../hooks/use-form-actions';
import { getForm } from '../controller-props';
import FormLoadingError from './form-loading-error/form-loading-error';
import Providers from './providers';
import { useSimulateError } from './use-simulate-error';
const Widget = ({ forwardedRef, controller, i18n, formId, values, stepId, onChange, onBlur, onFocus, onStepIdChange, errors, onValidate, onError, externalData, overrides, bi, biFormFillSessionId, forcedState, httpClient, fields, RicosViewer, panorama, onSubmit, onSubmitSuccess, onSubmitFailure, onStatusChange })=>{
    const { wfActions, wfConfig, wfResults } = controller;
    if (!wfActions || !wfConfig || !wfResults) {
        throw new Error('Missing controller props');
    }
    useSimulateError(wfConfig);
    const form = getForm(wfConfig, formId);
    const { formActions, inProgress } = useFormActions({
        wfActions,
        wfResults
    });
    return /*#__PURE__*/ React.createElement(Providers, {
        config: wfConfig
    }, form ? /*#__PURE__*/ React.createElement(FormViewerStatic, {
        httpClient: httpClient,
        ref: forwardedRef,
        actions: formActions,
        config: wfConfig,
        form: form,
        enableAutofill: !wfConfig.isEditor && !wfConfig.isComposer,
        values: values,
        stepId: stepId,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        onStepIdChange: onStepIdChange,
        errors: errors,
        onValidate: onValidate,
        onSubmit: onSubmit,
        onSubmitSuccess: onSubmitSuccess,
        onSubmitFailure: onSubmitFailure,
        onStatusChange: onStatusChange,
        isMobile: wfConfig.isMobile,
        isRTL: wfConfig.isRTL,
        i18n: i18n,
        bi: bi,
        biFormFillSessionId: biFormFillSessionId,
        externalData: externalData,
        translations: wfConfig.translations,
        localeDataset: wfConfig.localeDataset,
        overrides: overrides,
        forcedState: forcedState,
        inProgress: inProgress,
        experiments: wfConfig.experiments,
        currency: wfConfig.currency,
        fields: fields,
        RicosViewer: RicosViewer,
        fieldInitialData: wfConfig.fieldInitialData,
        panorama: panorama
    }) : /*#__PURE__*/ React.createElement(FormLoadingError, {
        formId: formId,
        i18n: i18n,
        translations: wfConfig.translations,
        language: wfConfig.language,
        onError: onError,
        isRTL: wfConfig.isRTL
    }));
};
export default Widget;

//# sourceMappingURL=widget.js.map